@if (avatarInitials; as avatar) {
  <div
    class="badge badge--{{ size() }} badge--{{ avatar.light ? 'light' : 'dark' }}"
    [style.background-color]="color() ?? avatar.color ?? 'var(--fill-neutral-expressive)'">
    <span class="badge__text">{{ avatar.initials }}</span>
  </div>
}
@if (avatarImage; as avatar) {
  <div
    class="badge badge--img badge--{{ size() }}"
    [class.badge__border]="enableBorder()"
    [style.background-color]="color() ?? 'var(--content-on-expressive)'">
    <img
      [src]="avatar.src"
      alt="avatar"
      class="badge__image"
      [style.width]="imageWidth()"
      [style.height]="imageHeight()" />
  </div>
}

@if (avatarIcon; as avatar) {
  <div
    class="badge badge--icon badge--{{ size() }}"
    [style.background-color]="avatar.bg_color ?? 'transparent'">
    <evc-icon
      [icon]="avatar.icon"
      [size]="size()"
      [style.color]="color() ?? avatar.color ?? 'var(--fill-neutral-expressive)'" />
  </div>
}
